webpackJsonp([78],{

/***/ 1327:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1328);


/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(170);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(769);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1327]);


// WEBPACK FOOTER //
// app/datetime.en-9d6a02c927799a3ca4a0.js